import IEnrichissement from '@/types/enrichissement.interface';
import http from './api.service';

class EnrichissementService {
    getPrice(enrichissement: IEnrichissement) {
        return http.post('/enrichment/getprice', enrichissement,
            {
                headers: { 'Content-Type': 'application/json' }
            })
    }

    order(enrichissement: IEnrichissement, user, basket) {
        return http.post('/enrichment/order', {...enrichissement, ...{basket: {...basket,...{email: user.email}}}},
            {
                headers: { 'Content-Type': 'application/json' },
                params: {userId: user.id}
        })
    }

    preview(enrichissement: IEnrichissement) {
        return http.post('/enrichment/preview', enrichissement,
            { headers: { 'Content-Type': 'application/json' }
        })
    }

    previewComptage(comptagePreview: any) {
        return http.post('/enrichment/previewcomptage', comptagePreview,
            { headers: { 'Content-Type': 'application/json' } 
        })
    }
}

export default new EnrichissementService();